////////LIBRARY/////////
import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector, shallowEqual } from 'react-redux'
import { isEmpty, isUndefined, find } from 'lodash'
import styled from 'styled-components'
import { bindActionCreators } from 'redux'
///////COMPONENTS///////
import ListEditable from '../../../components/ListEditable'
import { rolesManagerActionCreators } from '../../../store/actions'
import ToggleFilters from '../../../components/Ui/ToggleFilters'
import PrivateTagIcon from '../../../assets/icones/global/thumb-black.svg'
import Tooltip from '../../../components/Tooltip/Tooltip'
import { PageGridTitle, PageGridBorder, CreateButton } from '../../../theme/GlobalCss'
import userPrivileges from '../../../constants/PrivilegesList'
import TooltipHelp from '../../../components/TooltipHelp'
/////////ASSETS/////////
import PrivateTagIconSelected from '../../../assets//icones/global/thumb-white.svg'

//////STYLED//////
const RolesListManagerWrapper = styled.div`
	position: relative;
	font-size: ${(props) => props.theme.font.fs};
`
const ListActions = styled.div`
	position: relative;
	padding: 10px;
	display: flex;
	flex-direction: row;
`
//////STYLED//////

const RolesListManager = (props) => {
	const [checkedNivSort, setCheckedNivSort] = useState(false)
	const [sortColumnName, setSortColumnName] = useState('label')
	const [sortDir, setSortDir] = useState(1) // asc by default

	const { translations, rolesManager, user } = useSelector(
		(state) => ({
			translations: state.languages.translations,
			rolesManager: state.rolesManager,
			user: state.user,
		}),
		shallowEqual
	)

	const actionsRolesManager = bindActionCreators(rolesManagerActionCreators, useDispatch())

	///////////////////////////////// CONFIG ///////////////////////////////////////

	const config = {
		name: translations['page__roleManagement__roleSheet_select'],
		listEditableMarker: {
			translationsKey: 'tooltip__admin__roleManagement__privateRole',
			tooltipId: 'privateRole',
		},
	}

	const refListRoles = useRef()

	const columns = [
		// We set what data value is used to
		// For setting value of input
		{ isRadioValue: true, dataHook: 'id', headerName: 'id', sortable: false },
		// For labelling the item
		{ hasMarker: true, icon: PrivateTagIcon, iconSelected: PrivateTagIconSelected, dataHook: 'isPrivate' },
		{ isLabel: true, dataHook: 'label', headerName: 'label', sortable: true, alreadyTranslated: true, usingMarker: 'isPrivate' },
		// For adding additonal label (here role level)
		{
			isAdditionalLabel: !isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[11]))
				? true
				: false,
			dataHook: 'level',
			headerName: 'level',
			sortable: true,
		},
	]

	/////////////////////////////// USE EFFECT /////////////////////////////////////

	useEffect(() => {
		if (!isEmpty(translations)) {
			props.userMode ? actionsRolesManager.getRoles(true) : actionsRolesManager.getRoles(false)
		}
	}, [translations])

	useEffect(() => {
		if (!isEmpty(rolesManager.items)) {
			refListRoles.current = rolesManager.items
		} else {
			if (!isUndefined(refListRoles.current)) {
				setSortColumnName('label')
				setCheckedNivSort(false)
				setSortDir(1)
				actionsRolesManager.getRoles()
			}
		}
	}, [rolesManager.items])

	useEffect(() => {
		checkedNivSort ? setSortColumnName('level') : setSortColumnName('label')
	}, [checkedNivSort])

	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<RolesListManagerWrapper>
			<TooltipHelp content={'tooltipHelp__admin__modal__body__roleManagement__selectRole'} childrenPos={1} insideModal={props.userMode}>
				<PageGridTitle>{config.name}</PageGridTitle>
			</TooltipHelp>
			<PageGridBorder>
				<ListActions>
					<ToggleFilters
						checked={checkedNivSort}
						onChangeHandler={() => {
							setCheckedNivSort(!checkedNivSort)
						}}
						name="columnSort"
						labelPrev={translations['page__roleManagement__roleSheet_name']}
						labelNext={translations['page__roleManagement__roleSheet_level']}
					/>
					<ToggleFilters
						checked={sortDir}
						onChangeHandler={() => {
							setSortDir(sortDir === 0 ? 1 : 0)
						}}
						name="columnSort"
						sortPics
					/>
					{!isUndefined(find(user.identity.rolePrivileges.privileges, (o) => o.label === userPrivileges.action[11])) && (
						<Tooltip tooltipId={'roleCreate'} translationsKey={'tooltip__admin__global__create'}>
							<CreateButton onClick={() => props.showCreationModal()} />
						</Tooltip>
					)}
				</ListActions>
				<ListEditable
					inputData={rolesManager.items}
					inputColumns={columns}
					type="radio"
					translationMode={true}
					sortColumnName={sortColumnName}
					sortDir={sortDir}
					editMethod={props.showCreationModal}
					deleteMethod={props.showDeleteModal}
					listSelected={props.listSelected}
					currentListSelected={props.currentListSelected}
					ref={refListRoles}
					sizeHeightActions={392}
					keepSelected={props.keepSelected}
					config={config}
				/>
			</PageGridBorder>
		</RolesListManagerWrapper>
	)
}

RolesListManager.propTypes = {}

RolesListManager.defaultPropTypes = {}

export default RolesListManager
